import { get } from 'api/client';
import config from 'config';
import type { InstagramAudioPage, InstagramAudioTrack } from '../types';

type ApiResponse<T> = { data: T; meta?: { next_cursor?: string | null } };

function mapTrack(raw: Partial<InstagramAudioTrack>): InstagramAudioTrack {
  return {
    audio_id: String(raw.audio_id ?? ''),
    audio_type: raw.audio_type ?? null,
    title: raw.title ?? null,
    duration_in_ms: raw.duration_in_ms ?? null,
    display_artist: raw.display_artist ?? null,
    cover_artwork_thumbnail_uri: raw.cover_artwork_thumbnail_uri ?? null,
    ig_username: raw.ig_username ?? null,
    profile_picture_url: raw.profile_picture_url ?? null,
    download_url: raw.download_url ?? null,
    on_platform_audio_preview_link: raw.on_platform_audio_preview_link ?? null,
  };
}

export const InstagramAudioApi = {
  list(params: {
    pageId: number;
    audioType?: string;
    searchQuery?: string;
    cursor?: string;
  }): Promise<InstagramAudioPage> {
    return get<ApiResponse<Partial<InstagramAudioTrack>[]>>(
      `pages/${params.pageId}/instagram-audio`,
      {
        baseURL: config.API_SERVICE_ENDPOINT,
        params: {
          audio_type: params.audioType,
          search_query: params.searchQuery,
          cursor: params.cursor,
        },
      },
    ).then((response) => ({
      tracks: (response.data ?? []).map(mapTrack),
      nextCursor: response.meta?.next_cursor ?? null,
    }));
  },

  detail(params: {
    pageId: number;
    audioId: string;
  }): Promise<InstagramAudioTrack> {
    return get<Partial<InstagramAudioTrack>>(
      `pages/${params.pageId}/instagram-audio/${params.audioId}`,
      { baseURL: config.API_SERVICE_ENDPOINT },
    ).then(mapTrack);
  },

  publicDetail(params: {
    postId: number;
    token: string;
  }): Promise<InstagramAudioTrack> {
    return get<Partial<InstagramAudioTrack>>(
      `post/${params.postId}/instagram-audio`,
      {
        baseURL: config.PUBLIC_API_SERVICE_ENDPOINT,
        params: { token: params.token },
      },
    ).then(mapTrack);
  },
};
